import {
    REQUEST_PAYMENT_RECEIPT,
    SET_PAYMENT_LIST,
    SET_MAIN_PAYMENT_LIST
} from './mutation-types';

export default {
  [REQUEST_PAYMENT_RECEIPT] (state, receivedData) {
    state.payment = receivedData
  },
  [SET_PAYMENT_LIST] (state, receivedData) {
    state.paymentList = receivedData.content
  },
  [SET_MAIN_PAYMENT_LIST] (state, receivedData) {
    state.mainPaymentList = receivedData
  }
}